import {normalize} from 'normalizr'

import api from '../../api'
import {Probe} from "../../models"

// import project_schema from '../schema/project_schema'

const SET_INSTRUMENTTYPE_LIST = 'SET_INSTRUMENTTYPE_LIST'
const SET_INSTRUMENT_LIST = 'SET_ISTRUMENT_LIST'
const SET_PROJECT_LIST = 'SET_PROJECT_LIST'
const SET_SAMPLE_TYPE_LIST = 'SET_SAMPLE_TYPE_LIST'
// const SET_SAMPLE_LIST = 'SET_SAMPLE_LIST'
const SET_DYE_LIST = 'SET_DYE_LIST'
const SET_TREAT_LIST = 'SET_TREAT_LIST'
const SET_PROBE_LIST = 'SET_PROBE_LIST'
const SET_CALIBRATIONS = 'SET_CALIBRATION_LIST'

const SET_LISTS_READY = 'SET_LISTS_READY'

const initialState = {
	isReady: false,

	instrumentType_list: [],
	instrumentTypes: {},

	instrument_list: [],
	instruments: {},

	project_list: [],
	projects: {},

	sampleType_list: [],
	sampleTypes: {},

	// sample_list: [],
	// samples: {},

	dye_list: [],
	dyes: {},

	treat_list: [],
	treats: {},

	probe_list: [],
	probes: {},

	probePlex_list: [],
	probePlexes: {},

	calibration_list: [],
	calibrations: {},
}

const actions = {

	fetch: function ({commit, getters, dispatch}) {
		console.debug("store.lists.fetch()")

		return Promise.all([
			dispatch('lists/list_instrumentType', null, {root: true}),
			dispatch('lists/list_sampleType', null, {root: true}),
			dispatch('lists/list_project', null, {root: true}),
			dispatch('lists/list_dye', null, {root: true}),
			dispatch('lists/list_treat', null, {root: true}),
		])
			.then(function ([
				list_instrumentType_promise,
				list_sampleType_promise,
				list_project_promise,
				list_dye_promise,
				list_treat_promise,
			]) {
				return Promise.all([
					dispatch('lists/list_instrument', null, {root: true}),
					dispatch('lists/list_probe', null, {root: true}),
					dispatch('sample/list_sample', {project_id: null}, {root: true}),
				])
					.then(function ([
						list_instrument_promise,
						list_probe_promise,
						list_sample_promise,
					]) {
						return Promise.all([
							dispatch('probePlex/list_probePlex', {project_id: null}, {root: true})
						]).then(function ([list_probePlex_promise]) {

							commit(SET_LISTS_READY)
							console.debug('store.lists.fetchData()')
						})
					})
			})
	},

	list_instrumentType: function ({commit}) {
		console.debug('store.lists.list_instrumentType')

		return api.lists.list_instrumentType()
			.then(function (response) {
				commit(SET_INSTRUMENTTYPE_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_INSTRUMENTTYPE_LIST, [])
				throw error
			})
	},

	list_instrument: function ({commit}) {
		console.debug('store.lists.list_instrument')

		return api.lists.list_instrument()
			.then(function (response) {
				commit(SET_INSTRUMENT_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_INSTRUMENT_LIST, [])
				throw error
			})
	},

	list_project: function ({commit}) {
		console.debug('store.lists.list_project call')

		return api.lists.list_project()
			.then(function (response) {
				console.log('store.lists.list_project response')
				commit(SET_PROJECT_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_PROJECT_LIST, [])
				throw error
			})
	},

	list_sampleType: function ({commit}) {
		console.debug('store.lists.list_sample_type call')
		return api.lists.list_sample_type()
			.then(function (response) {
				console.log('store.lists.list_sample_type response')
				commit(SET_SAMPLE_TYPE_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_SAMPLE_TYPE_LIST, [])
				throw error
			})
	},

	// list_sample: function ({commit}) {
	// 	console.debug("store.lists.list_sample call")
	//
	// 	return api.lists.list_sample()
	// 		.then(function (response) {
	// 			console.log("store.lists.list_sample response")
	// 			commit(SET_SAMPLE_LIST, response.data)
	// 			return true
	// 		})
	// 		.catch(function (error) {
	// 			commit(SET_SAMPLE_LIST, [])
	// 			throw error
	// 		})
	// },

	list_dye: function ({commit}) {
		console.debug('store.lists.list_dye')

		return api.lists.list_dye()
			.then(function (response) {
				commit(SET_DYE_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_DYE_LIST, [])
				throw error
			})
	},

	list_treat: function ({commit}) {
		console.debug('store.lists.list_treat')

		return api.lists.list_treat()
			.then(function (response) {
				commit(SET_TREAT_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_TREAT_LIST, [])
				throw error
			})
	},

	list_probe: function ({commit, rootState}) {
		console.debug('store.lists.list_probe')

		return api.lists.list_probe()
			.then(function (response) {

				const data = Array.from(
					response.data,
					(p) => new Probe(p, rootState))

				commit(SET_PROBE_LIST, data)
				return true
			})
			.catch(function (error) {
				commit(SET_PROBE_LIST, [])
				throw error
			})
	},


// get_calibration({commit}) {
// 	return api.lists.getCalibrations()
// 		.then(function (response) {
// 			commit(SET_CALIBRATIONS, response.data)
// 			return true
// 		})
// 		.catch(function (error) {
// 			commit(SET_CALIBRATIONS, {})
// 			throw error
// 		})
// },

}

const mutations = {

	[SET_LISTS_READY](state, data) {
		state.isReady = true
	},

	[SET_INSTRUMENTTYPE_LIST](state, data) {
		state.instrumentType_list = data
		state.instrumentTypes = Object.assign({}, ...data.map((it) => ({[it.id]: it})))
	},

	[SET_INSTRUMENT_LIST](state, data) {
		state.instrument_list = data
		state.instruments = Object.assign({}, ...data.map((i) => ({[i.id]: i})))
	},

	[SET_PROJECT_LIST](state, data) {
		console.debug('store.lists.mutations.SET_PROJECT_LIST()')
		// state.project_list = normalize(data, project_schema)
		state.project_list = data
		state.projects = Object.assign({}, ...data.map((p) => ({[p.id]: p})))
	},

	[SET_SAMPLE_TYPE_LIST](state, data) {
		state.sampleType_list = data
		state.sampleTypes = Object.assign({}, ...data.map((st) => ({[st.id]: st})))
	},

	// [SET_SAMPLE_LIST](state, data) {
	// 	state.sample_list = data
	// 	state.samples = Object.assign({}, ...data.map((s) => ({[s.id]: s})))
	// },

	[SET_DYE_LIST](state, data) {
		state.dye_list = data
		state.dyes = Object.assign({}, ...data.map((d) => ({[d.id]: d})))
	},

	[SET_TREAT_LIST](state, data) {
		state.treat_list = data
		state.treats = Object.assign({}, ...data.map((d) => ({[d.id]: d})))
	},

	[SET_PROBE_LIST](state, data) {
		state.probe_list = data
		state.probes = Object.assign({}, ...data.map(
			(p) => ({[p.id]: p})))
	},

	[SET_CALIBRATIONS](state, data) {
		state.calibration_list = data
		state.calibrations = Object.assign({}, ...data.map((c) => ({[c.id]: c})))
	},

}

const getters = {

	project_list: function (state) {
		console.debug('store.lists.getters.project_list()')
		return state.project_list
	},

	/**
	 * Get projects dict by id
	 * @param state
	 * @returns {any}
	 */
	projects: function (state) {
		return state.projects
	},

	sampleType_list: function (state) {
		return state.sampleType_list
	},

	sampleTypes: function (state) {
		return state.sampleTypes
	},

	instrument_list: function (state) {
		return state.instrument_list
	},

	dye_list: function (state) {
		return state.dye_list
	},

	probe_list: function (state) {
		return state.probe_list
	},

	treat_list: function (state) {
		return state.treat_list
	},
}

export default {
	namespaced: true,
	state: initialState,
	actions,
	mutations,
	getters
}